<form #mfaSetupForm="ngForm" autocomplete="off" >
  <div class="m-auto">
    <div class="p-grid">
      <div class="p-col-12">
        <h3 class="title">Two-Factor Verification</h3>
      </div>
      @if (!verifying) {
        <div class="p-col-12">
          Please click the "Send Code" button to have your verification code sent to you.
        </div>
      }
      @if (!verifying) {
        <div class="p-col-12">
          If you need to change your two-factor verification preferences, please click the "Change Verification Preference" button.
        </div>
      }
      @if (verifying) {
        <div class="p-col-12">
          A code has been sent to you via your preferred method of communication. Please enter the code and click "Submit" to finish signing in.
        </div>
      }
      <div class="p-col-12">
      </div>
      @if (!verifying) {
        <div class="p-col-12">
          <p-button type="button" severity="success"label="Send Code" fluid (click)="sendCode()" [disabled]="disableSend"></p-button>
          <p-button type="button" severity="info" label="Change Verification Preference" fluid (click)="goToSetup()" [disabled]="disableSend"></p-button>
        </div>
      }
      @if (verifying) {
        <div class="p-col-12">
          <input
            #code
            type="text"
            maxlength="6"
            pattern="[0-9]{6}"
            pInputText
            [disabled]="waitingForVerification"
            [(ngModel)]="enteredCode"
            style="width: 300px; margin-bottom: 10px; margin-right: 5px;"
            name="code"
            />
            <p-button type="button" severity="success"label="Submit" fluid (click)="verifyCode()" [disabled]="disableSend" type="submit"></p-button>
          </div>
        }
        <div class="p-col-12">
          @if (responseMessage) {
            <p-message [severity]="success ? 'success' : 'error'" [text]="responseMessage" style="width:100%">
            </p-message>
          }
        </div>
      </div>
    </div>
  </form>